import { Building } from './building.model';
import { CancellationParamModel } from '../CancellationParam.model';

export class Service {
  public bookingEndHour: string;
  public bookingStartHour: string;

  public building: Building | string;
  public cost: number;
  public description: string;
  public id?: number;

  public isActive: boolean;
  public isAddedOnRoomBooking: boolean;

  public isAddedOnSession: boolean;
  public limitBeforeBooking: number;

  public name: string;
  public price: number;

  public quantityLimitAdmin: number;
  public quantityLimitUser: number;
  public billingLimit: number;

  constructor(json: any = {}) {
    if (json !== null) {
      Object.assign(this, json);
    }
  }
}
